import { fromApiDate } from 'src/helpers';
import type { IVendorLeadProduct } from 'src/types/vendors/IVendorLeadProduct';

export type IVendorLeadProductResponse = Pick<
  IVendorLeadProduct,
  | 'id'
  | 'ticketNumber'
  | 'companyName'
  | 'shippingAddress'
  | 'billingAddress'
  | 'contacts'
  | 'productTypeId'
  | 'initialQty'
  | 'specData'
  | 'submittedFieldGroups'
  | 'serviceType'
  | 'images'
  | 'sdsFiles'
> & {
  accessedAt: string;
};

export function toVendorLeadProduct(response: IVendorLeadProductResponse): IVendorLeadProduct {
  return {
    ...response,

    accessedAt: fromApiDate(response.accessedAt),
  };
}
